export default "__VITE_ASSET__Csiii8l3__"